import { FC, ReactElement } from 'react';

import { Skeleton } from '../../../../components';
import { generateIdArray } from '../../../../helpers/array';
import { randomInBetweenValue } from '../../../../helpers/number';

import './ProductListSkeletons.scss';

interface ProductListSkeletonsProps {
    numberOfSkeletons?: number;
    className?: string;
}

export const ProductListSkeletons: FC<ProductListSkeletonsProps> = ({
    numberOfSkeletons = randomInBetweenValue(4, 6),
    className = '',
}): ReactElement => {
    const productCardSkeletons = generateIdArray(numberOfSkeletons);

    return (
        <ul className={`product-list-skeletons ${className}`}>
            {productCardSkeletons.map(skeleton => (
                <li key={skeleton} className="product-list-skeletons__list-item">
                    <div className="product-list-skeletons__image" />

                    <div className="product-list-skeletons__meta-wrapper">
                        <Skeleton className="product-list-skeletons__meta" />
                    </div>

                    <Skeleton className="product-list-skeletons__title" />

                    <div className="product-list-skeletons__button-wrapper">
                        <Skeleton className="product-list-skeletons__button" />
                    </div>
                </li>
            ))}
        </ul>
    );
};
